import { useMerchant, useMerchantGroup } from '@domain/merchants/queries';

export const useMerchantDisplayName = (): string => {
  const { data: merchant } = useMerchant();
  const { data: group } = useMerchantGroup();
  return merchant?.name || group?.name || '';
};
